var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#74ACDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15h60v15H0V15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.712 22.617 2.565 5.58s.045.108.117.081c.072-.036.027-.144.027-.144l-2.133-5.76m-.063 2.178c-.036.846.486 1.314.423 2.07-.072.765.342 1.188.45 1.485.09.297-.108.468-.027.513.09.045.27-.189.216-.612-.063-.414-.378-.54-.306-1.467.072-.927-.378-1.143-.27-1.98",
    fill: "#F6B40E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m32.467 28.116-2.133-5.76-.092.035 2.133 5.761v.001l.001.003a.148.148 0 0 1 .01.04c0 .022-.004.032-.012.037-.005 0-.014 0-.028-.018a.148.148 0 0 1-.022-.034l-.001-.002v-.001l-1.578-3.432c.002-.056.007-.116.015-.178l-.098-.013-.001.008-.904-1.967-.09.042.978 2.128c-.008.314.066.539.14.767l.002.003c.089.272.18.55.145 1.001-.037.47.025.741.105.948.026.066.055.127.081.184l.04.086a.997.997 0 0 1 .08.26.839.839 0 0 1-.05.454.26.26 0 0 1-.068.095.07.07 0 0 1-.018.01.357.357 0 0 1 .012-.041l.006-.016.015-.043c.03-.09.06-.219.01-.381v-.002a1.833 1.833 0 0 0-.13-.258l-.004-.007a3.738 3.738 0 0 1-.16-.306 1.706 1.706 0 0 1-.154-.893c.033-.388-.084-.702-.201-1.016l-.003-.007c-.118-.318-.236-.638-.219-1.05l-.099-.004c-.018.434.107.771.225 1.088.119.319.229.615.199.98-.037.393.05.698.161.943.054.118.113.222.164.313l.005.008c.053.094.097.171.122.24.04.135.016.24-.01.32l-.014.04a.9.9 0 0 0-.022.07.125.125 0 0 0 0 .058.085.085 0 0 0 .042.053l.002.001c.047.024.096.006.132-.022a.357.357 0 0 0 .097-.131.938.938 0 0 0 .058-.51c-.017-.11-.05-.2-.088-.286a4.62 4.62 0 0 0-.042-.092 2.789 2.789 0 0 1-.076-.174c-.075-.192-.135-.447-.1-.904.037-.471-.06-.764-.15-1.04v-.003a2.482 2.482 0 0 1-.125-.498l1.477 3.213v.001l.001.002.001.003a.237.237 0 0 0 .037.057c.024.028.074.07.14.044h.003l.002-.002c.063-.031.07-.094.068-.133a.25.25 0 0 0-.015-.067l-.001-.005Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.387 24.696c.045.81.504 1.17.414 1.917.198-.585-.279-1.044-.252-1.908m-.693-2.142 1.755 3.834-1.467-3.95",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25.003a2.503 2.503 0 1 0 0-5.006 2.503 2.503 0 0 0 0 5.006Z",
    fill: "#F6B40E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20.062a2.437 2.437 0 1 0 0 4.875 2.437 2.437 0 0 0 0-4.875ZM27.43 22.5a2.569 2.569 0 1 1 5.137 0 2.569 2.569 0 0 1-5.137 0Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.844 21.966a.497.497 0 0 0-.422.225c.187.178.619.187.91-.019a.658.658 0 0 0-.479-.206h-.01Zm0 .037c.168 0 .328.075.347.15-.188.216-.497.188-.694.038a.428.428 0 0 1 .356-.188h-.01Z",
    fill: "#843511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.625 22.847a.168.168 0 1 0 .169.272.375.375 0 0 0 .206.056h.019c.056 0 .15-.01.215-.056.028.046.085.065.14.065a.17.17 0 0 0 .029-.337.113.113 0 0 1 .075.112.112.112 0 1 1-.225 0 .28.28 0 0 1-.244.16.281.281 0 0 1-.234-.16c0 .066-.056.113-.122.113a.121.121 0 0 1-.113-.113c0-.056.029-.094.075-.112h.01Zm.187.506c-.197 0-.28.187-.45.29.094-.037.17-.112.31-.187.13-.075.243.019.328.019.075 0 .187-.094.328-.019.131.075.216.15.31.188-.179-.113-.254-.282-.45-.282a.497.497 0 0 0-.188.057l-.188-.066Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.738 23.587c-.075 0-.17.019-.32.056.348-.075.423.047.582.047.15 0 .235-.122.572-.047-.375-.112-.46-.037-.572-.037-.075 0-.131-.028-.262-.019Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.437 23.644h-.075c.403.047.216.281.638.281.422 0 .234-.234.637-.281-.422-.038-.29.216-.637.216-.328 0-.225-.216-.563-.216Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.347 24.272a.347.347 0 0 0-.694 0 .357.357 0 0 1 .694 0ZM28.444 21.966c.44-.385 1.003-.45 1.312-.16a.75.75 0 0 1 .141.32c.038.224-.028.459-.197.702l.075.038c.15-.29.206-.59.15-.881l-.056-.216c-.422-.347-1.003-.375-1.425.188v.009Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.137 21.844c.253 0 .31.056.422.16.113.093.178.074.188.093.028.019 0 .075-.028.056a.871.871 0 0 1-.235-.15c-.112-.094-.234-.094-.347-.094-.346 0-.534.282-.572.263-.046-.019.188-.328.572-.328Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.147 22.322a.169.169 0 1 0 0-.338.169.169 0 0 0 0 .338Z",
    fill: "#85340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.678 22.265c.328.254.656.235.844.122.188-.122.188-.159.15-.159-.038 0-.075.037-.225.122-.16.075-.384.075-.769-.085Z",
    fill: "#85340A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArsFlag);
export default __webpack_public_path__ + "static/media/ars-flag.710fd3edefd16305f46119f0a22c18a9.svg";
export { ForwardRef as ReactComponent };